var DB_preorder_count = {
    startpreorderNumber: 1000,
    preorderStartDateCompteur:0,
    timeElapsed:0,
    newPreorderNumber:0,
    tableNumber:0,
    init:function(){
        DB_preorder_count.preorderStartDateCompteur = new Date("2024-08-17T09:00:00").getTime()
        
        DB_preorder_count.setSpanNumber(DB_preorder_count.startpreorderNumber);
        DB_preorder_count.loadPageDecrement(DB_preorder_count.startpreorderNumber,978);     
        DB_preorder_count.lowDecrementInit();
        DB_preorder_count.timeElapsed = (Date.now() - DB_preorder_count.preorderStartDateCompteur) / 1000 / 60 / 60
        console.log( "!!!!!!! PREORDER INIT : " + DB_preorder_count.timeElapsed);
        DB_preorder_count.newPreorderNumber = 978 - Math.round(DB_preorder_count.timeElapsed) * 1 > 0 ? 978 - Math.round(DB_preorder_count.timeElapsed) * 1 : 0
        DB_preorder_count.loadPageDecrement(DB_preorder_count.startpreorderNumber,DB_preorder_count.newPreorderNumber);          
    },
    loadPageDecrement:function(start, end) {
      const speedDecrement = setInterval(() => {

            let spanNumber;
            let stickySpanNumber;
            
            if(start > end){
                /*let randomNumber = gsap.utils.random(7, 11, 1);*/
                
                let randomNumber = Math.round(7 + Math.random() * 4);
                
                if (start < end + 30) randomNumber = 1;
            
                start -= randomNumber;

                if(start >= 1000){
                    spanNumber = Array.from(document.querySelectorAll('.preorder-qty span'));
                    /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span'));*/ 
                }
                else if(start >= 100){
                    spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2'));
                    /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2'));*/
                    document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
                    /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
                }
                else if (start >= 10){
                    spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2.number-3'));
                    /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2.number-3'));*/
                    document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
/*                    document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
                    document.querySelector('.preorder-qty span:nth-child(2)').innerText = '0';
                    /*document.querySelector('.sticky-preorder-qty span:nth-child(2)').innerText = '0';*/
                } else {
                    spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2.number-3.number-4'));
                    /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2.number-3.number-4'));*/
                    document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
                    /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
                    document.querySelector('.preorder-qty span:nth-child(2)').innerText = '0';
                    /*document.querySelector('.sticky-preorder-qty span:nth-child(2)').innerText = '0';*/
                    document.querySelector('.preorder-qty span:nth-child(3)').innerText = '0';
                    /*document.querySelector('.sticky-preorder-qty span:nth-child(3)').innerText = '0';*/
                }
    
                DB_preorder_count.tableNumber = DB_preorder_count.splitIntoArray(start)
    
                DB_preorder_count.updateNumber(spanNumber, DB_preorder_count.tableNumber);
                /*DB_preorder_count.updateNumber(stickySpanNumber, DB_preorder_count.tableNumber);*/
            } else{
                clearInterval(speedDecrement);
                DB_preorder_count.lowDecrement();
            }
        }, 5);
    },
    setSpanNumber:function(nb){
        nbTable = DB_preorder_count.splitIntoArray(nb)
        if(nbTable.length === 3){
            const spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number'));
            /*const stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number'));*/
            console.log(document.querySelector('.preorder-qty span:nth-child(1)'));
            document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
            console.log("JE SUIS A 0");
            /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
            DB_preorder_count.updateNumber(spanNumber, nbTable);
            /*DB_preorder_count.updateNumber(stickySpanNumber, nbTable);*/
        } else if(nbTable.length === 4){
            const spanNumber = Array.from(document.querySelectorAll('.preorder-qty span'));
            /*const stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span'));*/
            DB_preorder_count.updateNumber(spanNumber, nbTable);
            /*DB_preorder_count.updateNumber(stickySpanNumber, nbTable);*/
        }
        
    },
    lowDecrement:function(){
        const lowInterval = setInterval(() => {
        let spanNumber;
        let stickySpanNumber;

        /*let randomNumber = gsap.utils.random(2, 3, 1);*/
        let randomNumber = Math.round(2 + Math.random());
        
        DB_preorder_count.startpreorderNumber -= randomNumber;

        if(DB_preorder_count.startpreorderNumber >= 1000){
            spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number'));
            /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number'));*/
        }
        else if(DB_preorder_count.startpreorderNumber >= 100){
            spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2'));
            /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2'));*/
            document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
        }
        else if (DB_preorder_count.startpreorderNumber >= 10){
            spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2.number-3'));
            /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2.number-3'));*/
            document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
            document.querySelector('.preorder-qty span:nth-child(2)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(2)').innerText = '0';*/
        } else {
            spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number.number-2.number-3.number-4'));
            /*stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number.number-2.number-3.number-4'));*/
            document.querySelector('.preorder-qty span:nth-child(1)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(1)').innerText = '0';*/
            document.querySelector('.preorder-qty span:nth-child(2)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(2)').innerText = '0';*/
            document.querySelector('.preorder-qty span:nth-child(3)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(3)').innerText = '0';*/
        }

        DB_preorder_count.tableNumber = DB_preorder_count.splitIntoArray(DB_preorder_count.startpreorderNumber)

        if(DB_preorder_count.startpreorderNumber >= 0){
            DB_preorder_count.updateNumber(spanNumber, DB_preorder_count.tableNumber);
            /*DB_preorder_count.updateNumber(stickySpanNumber, DB_preorder_count.tableNumber);*/
        } 
        else{
            clearInterval(lowInterval);
            document.querySelector('.preorder-qty span:nth-child(4)').innerText = '0';
            /*document.querySelector('.sticky-preorder-qty span:nth-child(4)').innerText = '0';*/
        }
        }, 60*60*1000)
    },
    lowDecrementInit:function(){
        const spanNumber = Array.from(document.querySelectorAll('.preorder-qty span.number'));
        /*const stickySpanNumber = Array.from(document.querySelectorAll('.sticky-preorder-qty span.number'));*/

        DB_preorder_count.tableNumber = DB_preorder_count.splitIntoArray(DB_preorder_count.startpreorderNumber)

        DB_preorder_count.updateNumber(spanNumber, DB_preorder_count.tableNumber);
        /*DB_preorder_count.updateNumber(stickySpanNumber, DB_preorder_count.tableNumber);*/
    },
    updateNumber:function(DOMElt, arrayNumber){
        if(arrayNumber.length === 3){
          Array.from(document.querySelectorAll('.preorder-qty span.number'))[4].innerText = '0';
          Array.from(document.querySelectorAll('.preorder-qty span.number'))[8].innerText = '0';
        }
        DOMElt.forEach((nb, index) => {
          
            console.log('INDEX : '+index);
            if(index >= arrayNumber.length ){
              index = index % arrayNumber.length;
            }
            
            console.log('NEW INDEX : '+index);
            console.log('NUMBER : '+arrayNumber[index]);
            if (arrayNumber[index] == undefined) {
              nb.innerText = '0';
            } else {
              nb.innerText = arrayNumber[index];
            }
            
        }) 
    },

    splitIntoArray:function(num) {
        return Array.from(String(num), Number);
    }

}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-preorder-count").length > 0){
        DB_preorder_count.init();
    }
})